import { BankOpening } from "@models/clients/bankOpening";
import { ClientCRMRepo } from "@services/clients/clientCRM.repo";

class BankController {
  public bank: BankOpening;
  public isLoading: boolean = false;
  public isEditMode: boolean = false;
  public bankForm: angular.IFormController;

  /** @ngInject */
  constructor(
    private $mdDialog: angular.material.IDialogService,
    private clientCRMRepo: ClientCRMRepo
  ) {}

  $onInit() {
    
    // Initialize bank object - create a copy to avoid modifying the original
    if (this.bank) {
      this.bank = { ...this.bank }; // Create a shallow copy
      this.isEditMode = this.bank.id > 0;
    } else {
      this.bank = { id: 0, name: '' };
      this.isEditMode = false;
    }
  }

  public saveBank() {
    // Trigger form validation
    this.bankForm.$setSubmitted();
    
    // Check if form is valid
    if (this.bankForm.$invalid) {
      return;
    }

    this.isLoading = true;
    
    // Call the single saveBank endpoint - backend will determine if it's create or update based on the ID
    this.clientCRMRepo.saveBank(this.bank)
      .then((result) => {
        this.$mdDialog.hide(this.bank);
      })
      .catch((error) => {
        console.error('Error saving bank:', error);
        // You could add error handling/notification here
        this.isLoading = false;
      });
  }

  public cancel() {
    this.$mdDialog.cancel();
  }
}

export const bankModal: angular.IComponentOptions = {
  template: require("./bank.html"),
  controller: BankController,
  bindings: {
    bank: "<?"
  }
};



// WEBPACK FOOTER //
// ./src/app/clientmanagement/modals/bank.ts